import Boolean from "./Boolean.vue";
import Texto from "./Text.vue";
import Email from "./Email.vue";
import Password from "./Password.vue";
import Slider from "./Slider.vue";
import Ranking from "./Ranking.vue";
import Number from "./Number.vue";
import Currency from "./Currency.vue";
import UniqueChoice from "./UniqueChoice.vue";
import MultiChoice from "./MultiChoice.vue";
import Barcode from "./Barcode.vue";

export const Components = {
  Boolean,
  Texto,
  Email,
  Password,
  Slider,
  Ranking,
  Number,
  Currency,
  UniqueChoice,
  MultiChoice,
  Barcode
};
